<template>
  <div>
    <div style="display: flex;">
      <v-btn
        color="#4d48f9"
        style="
          text-transform: none !important;
          color: white;
          margin-right: 30px;
        "
        @click="routeCampaignAdd()"
      >
        YENİ KAMPANYA EKLE
      </v-btn>
      <v-btn
        color="#4d48f9"
        style="text-transform: none !important; color: white;"
        @click="routeGroupCampaignAdd()"
      >
        GRUP KAMPANYASI EKLE
      </v-btn>
    </div>

    <h2 style="margin-top: 30px; margin-bottom: 10px; font-weight: 500;">
      UserApp Kampanyalar
    </h2>
    <v-tabs color="black" v-model="activeTab">
      <v-tab v-for="(tab, index) in tabs" :key="index">
        {{ tab.name }}
      </v-tab>
      <v-tab-item v-for="(tab, index) in tabs" :key="index">
        <v-container style="margin-left: 0;">
          <template v-if="index === 0">
            <v-row>
              <v-col cols="12" md="4" sm="4">
                <h4>Kampanya Tipi</h4>
                <v-select
                  v-model="campaignPageData.filterByCampaign"
                  @change="filterByCampaignChanged"
                  :items="campaignFilterItems"
                  item-text="name"
                  item-value="value"
                  data-vv-name="select"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <h4>Aktiflik/Pasiflik</h4>
                <v-select
                  v-model="campaignPageData.isActive"
                  @change="filterByCampaignStatus"
                  :items="statusFilterItems"
                  item-text="name"
                  item-value="value"
                  data-vv-name="select"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <h4>Segment</h4>
                <v-select
                  v-model="campaignPageData.filterBySegment"
                  @change="filterBySegmentStatus"
                  :items="
                    ['', ...allSegments].map((segment, i) => {
                      const segmentType = allSegmentTypes.find(
                        (x) => x.value == segment,
                      )
                      return {
                        value: segment,
                        label: segmentType ? segmentType.label : '',
                      }
                    })
                  "
                  item-text="label"
                  item-value="value"
                  data-vv-name="select"
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      :label="'Başlangıç tarihi'"
                      style="font-weight: bold;"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    :max="new Date().toISOString().substr(0, 10)"
                    @change="filterByDateChange(date, endDate)"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-menu
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endDate"
                      :label="'Bitiş tarihi'"
                      style="font-weight: bold;"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    :min="nowDate"
                    :disabled="datePickerDisable"
                    :max="
                      new Date(
                        new Date().getFullYear() + 1,
                        new Date().getMonth(),
                        new Date().getDate(),
                      )
                        .toISOString()
                        .substr(0, 10)
                    "
                    @change="filterByDateChange(date, endDate)"
                    @input="menu3 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-row cols="12" md="4">
                <v-icon
                  style="font-size: 17px;"
                  v-if="!alertPriority"
                  color="#4d48f9"
                  @click="alertPriority = !alertPriority"
                >
                  info
                </v-icon>

                <v-alert
                  v-model="alertPriority"
                  border="left"
                  close-text="Close Alert"
                  color="#4d48f9"
                  dark
                  dismissible
                >
                  Son Kullanma Tarihi seçilen başlangıç ve bitiş tarihi arasında
                  olan kampanyaları filtreler.
                </v-alert>
              </v-row>

              <v-col cols="12" md="4" sm="4" style="margin-top: -24px;">
                <h4>Paket Adı</h4>
                <v-select
                  v-model="campaignPageData.filterBySubscriptionType"
                  @change="filterBySubscriptionType"
                  :items="
                    allSubscriptionTypes.map((subscription) => {
                      return {
                        label: subscriptionLabels[subscription],
                        value: allSubscriptionTypes.indexOf(subscription),
                      }
                    })
                  "
                  item-text="label"
                  item-value="value"
                  data-vv-name="select"
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Ara"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-card>
              <v-data-table
                style="margin-top: 30px;"
                :loading="loading"
                :headers="headers"
                :items="allCampaigns"
                :footer-props="{
                  'items-per-page-options': [10, 25, 50, 100],
                  disablePagination: true,
                }"
                :items-per-page="10"
                @update:page="getPageNumber"
                @update:items-per-page="getItemPerPage"
              >
                <template v-slot:item.isShown="{ item }">
                  <v-checkbox
                    v-model="item.isShown"
                    color="#4d48f9"
                    @change="campaignVisibilityChange(item)"
                  ></v-checkbox>
                </template>
                <template v-slot:item.isActive="{ item }">
                  <v-checkbox
                    v-model="item.isActive"
                    color="#4d48f9"
                    @change="campaignStatusChange(item)"
                  ></v-checkbox>
                </template>
                <template v-slot:item.subscriptionType="{ item }">
                  {{
                   subscriptionLabels[item.subscriptionType]
                  }}
                </template>
                <template v-slot:item.codeType="{ item }">
                  {{
                   codeTypeLabels[item.codeType]
                  }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="routeCampaignEdit(item)">
                    mdi-pencil
                  </v-icon>
                </template>

                <template v-slot:item.endDate="{ item }">
                  <div class="tooltip-container">
                    <v-tooltip v-if="tooltipMessage(item).message" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          :style="{ color: tooltipMessage(item).color }"
                          v-on="on"
                        >
                          {{ tooltipMessage(item).icon }}
                        </v-icon>
                      </template>
                      <span>{{ tooltipMessage(item).message }}</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
              <div class="text-xs-center pt-2">
                <v-pagination
                  v-model="campaignPageData.pageNumber"
                  color="#4d48f9"
                  :length="pagination.pagesLength"
                  @input="setPageNumber"
                ></v-pagination>
              </div>
            </v-card>
          </template>
          <template v-else-if="index === 1">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="searchGroup"
                  append-icon="mdi-magnify"
                  label="Ara"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-card>
              <v-data-table
                style="margin-top: 30px;"
                :loading="loading"
                :headers="headersGroup"
                :items="allGroupCampaigns"
                :footer-props="{
                  'items-per-page-options': [10, 25, 50, 100],
                  disablePagination: true,
                }"
                :items-per-page="10"
                @update:page="getPageNumberGroup"
                @update:items-per-page="getItemPerPageGroup"
              >
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="routeGroupCampaignEdit(item)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
              </v-data-table>
              <div class="text-xs-center pt-2">
                <v-pagination
                  v-model="campaignGroupPageData.pageNumber"
                  color="#4d48f9"
                  :length="paginationGroup.pagesLength"
                  @input="setGroupPageNumber"
                ></v-pagination>
              </div>
            </v-card>
          </template>
        </v-container>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Campaigns',
  data: () => ({
    search: '',
    searchGroup: '',
    showToolTip: false,
    showToolTipGroup: false,

    campaignFilterItems: [
      {
        name: 'Hepsi',
        value: '',
      },
      {
        name: 'Kupon Kodu',
        value: 'CouponCode',
      },
      {
        name: 'İş Ortaklığı',
        value: 'Partnership',
      },
      {
        name: 'Genel Kampanya',
        value: 'General',
      },
    ],
    statusFilterItems: [
      {
        name: 'Hepsi',
        value: null,
      },
      {
        name: 'Aktif',
        value: true,
      },
      {
        name: 'Pasif',
        value: false,
      },
    ],
    campaignPageData: {
      pageNumber: 1,
      pageSize: 10,
      search: '',
      filterByCampaign: '',
      isActive: null,
      filterBySegment: '',
      filterBySubscriptionType: 2,
      startDate: null,
      endDate: null,
      campaignGroupId: null,
    },
    campaignGroupPageData: {
      pageNumber: 1,
      pageSize: 10,
      searchGroup: '',
    },
    campaignLinkTypes: [
      {
        name: 'İç Link',
        value: 'InternalLink',
      },
      {
        name: 'Dış Link',
        value: 'ExternalLink',
      },
    ],
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    paginationGroup: {
      totalItems: 20,
      pagesLength: 0,
    },
    alertPriority: false,
    nowDate: '',
    datePickerDisable: true,
    date: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    menu3: false,
    headers: [
      { text: 'Kampanya ID', value: 'id', align: 'start', sortable: false },
      { text: 'Kampanya Başlık', value: 'title', sortable: false },
      { text: 'Kod Tipi', value: 'codeType', sortable: false },
      { text: 'Kullanılmış Kod/Toplam Kod', value: 'percent', sortable: false },

      { text: 'Kampanyalarda Göster', value: 'isShown', sortable: false },
      { text: 'Aktif/Pasif', value: 'isActive', sortable: false },
      { text: 'Öncelik', value: 'priority', sortable: false },
      { text: 'Detay', value: 'actions', sortable: false },
      { text: 'Kupon Durum', value: 'endDate', sortable: false },
      { text: 'Paket Adı', value: 'subscriptionType', sortable: false },
    ],
    headersGroup: [
      {
        text: 'Grup Kampanya ID',
        value: 'id',
        align: 'start',
        sortable: false,
      },
      { text: 'Grup Kampanya Başlık', value: 'title', sortable: false },
      {
        text: 'Alt Kampanya Sayısı',
        value: 'subCampaignCount',
        sortable: false,
      },
      { text: 'Kullanılmış Kod/Toplam Kod', value: 'percent', sortable: false },
      { text: 'Detay', value: 'actions', sortable: false },
    ],
    activeTab: 0,
    tabs: [
      {
        name: 'Genel Kampanyalar',
      },
      {
        name: 'Grup Kampanyaları',
      },
    ],
  }),
  computed: {
    ...mapGetters([
      'allCampaigns',
      'loading',
      'allSegments',
      'allGroupCampaigns',
      'allSubscriptionTypes',
      'allSegmentTypes',
      'subscriptionLabels',
      'codeTypeLabels'
    ]),
  },
  created() {
    const page = this.$route.query.page ? Number(this.$route.query.page) : 1
    const groupPage = this.$route.query.groupPage
      ? Number(this.$route.query.groupPage)
      : 1

    this.campaignPageData.pageNumber = page
    this.campaignGroupPageData.pageNumber = groupPage
    this.getCampaigns(this.campaignPageData).then((response) => {
      this.pagination.totalItems = response.totalCount
      this.pagination.pagesLength = response.totalPages
    })
    this.getGroupCampaigns(this.campaignGroupPageData).then((response) => {
      this.paginationGroup.totalItems = response.totalCount
      this.paginationGroup.pagesLength = response.totalPages
    })
    this.getSegments()
    this.getSubscriptionTypes()
  },
  methods: {
    ...mapActions([
      'getCampaigns',
      'getGroupCampaigns',
      'updateCampaignStatus',
      'updateCampaignVisibility',
      'getSegments',
      'getSubscriptionTypes',
    ]),
    tooltipMessage(item) {
      const endDate = new Date(item.endDate)
      const today = new Date()
      const oneWeekFromNow = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000)
      if (endDate < today) {
        return {
          message: 'Bu kampanya süresi sona erdi',
          icon: 'mdi-exclamation',
          color: 'crimson',
        }
      } else if (endDate <= oneWeekFromNow) {
        return {
          message: 'Bu kampanya yakında sonlanacaktır',
          icon: 'mdi-timelapse',
          color: '#FFCD3F',
        }
      }
      return { message: '', icon: '' }
    },
    //Data table item per page changed function
    getItemPerPage(val) {
      console.log('getItemPerPage')
      this.campaignPageData.pageSize = val
      this.campaignPageData.pageNumber = 1
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
      })
    },
    getItemPerPageGroup(val) {
      this.campaignGroupPageData.pageSize = val
      this.campaignGroupPageData.pageNumber = 1
      this.getGroupCampaigns(this.campaignGroupPageData).then((response) => {
        this.pagination.pagesLength = response.totalPages
      })
    },
    //Data table page number changed function
    getPageNumber(val) {
      this.campaignPageData.pageNumber = val
      this.getCampaigns(this.campaignPageData)
    },
    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return
      this.$router.push({ path: this.$route.fullPath, query: { page: val } })
    },
    getPageNumberGroup(val) {
      this.campaignGroupPageData.pageNumber = val
      this.getGroupCampaigns(this.campaignGroupPageData)
    },
    setGroupPageNumber(val) {
      if (
        (!this.$route.query.groupPage && val == 1) ||
        this.$route.query.groupPage == val
      )
        return
      this.$router.push({
        path: this.$route.fullPath,
        query: { groupPage: val },
      })
    },
    filterByCampaignChanged(value) {
      this.campaignPageData.filterByCampaign = value
      this.campaignPageData.pageNumber = 1
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    filterByCampaignStatus(value) {
      this.campaignPageData.isActive = value
      this.campaignPageData.pageNumber = 1
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    filterBySegmentStatus(value) {
      this.campaignPageData.filterBySegment = value
      this.campaignPageData.pageNumber = 1
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    //CampaignAdd
    routeCampaignAdd() {
      this.$router.push('campaign')
    },
    //GroupCampaignAdd
    routeGroupCampaignAdd() {
      this.$router.push('groupCampaign')
    },
    //CampaignStatus
    campaignStatusChange(campaign) {
      this.updateCampaignStatus(campaign)
        .then((response) => {
          if (response.processStatus == 'Success') {
            alert('Güncelleme işlemi başarılıdır')
          } else {
            alert('Bir hata oluştu')
          }
        })
        .catch((err) => {
          alert(err)
        })
    },
    campaignVisibilityChange(campaign) {
      this.updateCampaignVisibility(campaign)
        .then((response) => {
          if (response.processStatus == 'Success') {
            alert('Güncelleme işlemi başarılıdır')
          } else {
            alert('Bir hata oluştu')
          }
        })
        .catch((err) => {
          alert(err)
        })
    },
    getItemPerSearch(val) {
      this.campaignPageData.pageNumber = 1
      this.campaignPageData.search = val
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    getGroupItemPerSearch(val) {
      this.campaignGroupPageData.pageNumber = 1
      this.campaignGroupPageData.searchGroup = val
      this.getGroupCampaigns(this.campaignGroupPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    //CampaignEdit
    routeCampaignEdit(item) {
      this.$router.push(`campaign/${item.id}`)
    },
    redirectLink(endpoint) {
      console.log(endpoint)
      window.open(
        endpoint,
        '_blank', // <- This is what makes it open in a new window.
      )
    },
    //GroupCampaignDetail
    routeGroupCampaignEdit(item) {
      this.$router.push(`groupCampaign/${item.id}`)
    },
    filterByDateChange(startDate, endDate) {
      startDate = startDate.split(/[- :]/)
      this.campaignPageData.startDate =
        startDate[2] + '-' + startDate[1] + '-' + startDate[0]

      endDate = endDate.split(/[- :]/)
      this.campaignPageData.endDate =
        endDate[2] + '-' + endDate[1] + '-' + endDate[0]

      this.campaignPageData.pageNumber = 1
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    filterBySubscriptionType(value) {
      this.campaignPageData.filterBySubscriptionType = value
      this.campaignPageData.pageNumber = 1
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
  },

  watch: {
    date: function () {
      this.nowDate = this.date
      this.datePickerDisable = false
    },
    search: function (val, oldVal) {
      if (val.length < 2 && oldVal.length < 1) return
      this.getItemPerSearch(val)
    },
    searchGroup: function (val, oldVal) {
      if (val.length < 2 && oldVal.length < 1) return
      this.getGroupItemPerSearch(val)
    },
    '$route.query.page'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumber(pageNumber)
    },
    '$route.query.groupPage'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumberGroup(pageNumber)
    },
  },
}
</script>

<style scoped>
.tooltip-container {
  display: flex;
}
</style>
